module.exports = __webpack_public_path__ + "img/part3-1.1208aad9.png";